import * as actions from '../actions/usersList';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function requestAragUserById(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_ARAG_USER_BY_ID)
        .map(action => ({
            url: BASE_URL + 'api/users/AragUsers/' + action.payload.aragUserId,
            category: 'requestAragUserById',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestAragUserById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getAragUserByIdSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestAragUserByIdFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestAragUserById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getAragUserByIdFail(response));

    return {
        ACTION: httpResponse$
    }
}

export function requestUserLevels(sources) {
	const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_USER_LEVELS)
        .map(action => ({
            url: BASE_URL + 'api/users/Levels',
            category: 'requestUserLevels',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestUserLevels')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getUserLevelsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestUserLevelsFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestUserLevels')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getUserLevelsFail(response));

    return {
        ACTION: httpResponse$
    }
}

export function requestUserGroups(sources) {
	const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_USER_GROUPS)
        .map(action => ({
            url: BASE_URL + 'api/users/Groups',
            category: 'requestUserGroups',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestUserGroups')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getUserGroupsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestUserGroupsFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestUserGroups')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getUserGroupsFail(response));

    return {
        ACTION: httpResponse$
    }
}

//TODO: this should be a get request
export function getUsers(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_USERS)
		.map(action => ({
			url: BASE_URL + 'api/users/AragUsers',
			category: 'getUsers',
			method: 'GET',
			send: {
				role: "User"
			},
			type: 'application/json',
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http get requests, it updates the redux store with the lawsys agents
	let httpResponse$ = sources.HTTP
		.select('getUsers')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetUsers(response));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failedGetUsers(sources) {
	let httpResponse$ = sources.HTTP
		.select('getUsers')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestGetUsers(response));

	return {
		ACTION: httpResponse$
	}
}